import * as INFO_TYPE from "2g-constants/informationTypes";

import { STAV } from "b2b/constants/zadosti";

export default {
  [STAV.PRIJATY]: INFO_TYPE.DANGER,
  [STAV.POTVRZENY]: INFO_TYPE.SUCCESS
};
